import { styled } from 'css-literal-loader/styled';
import withProps from 'recompose/withProps';
import Layout from '@4c/layout';

import Card from './Card';
import PageSegment from './PageSegment';

const WIDTH = 968;
export const PageSegmentContent = withProps({ flushXl: true })(
  styled(PageSegment.Content, null, "PageSegmentContent", require("./CrossSegmentCard-PageSegmentContent.module.scss"), "page-segment-content", "pageSegmentContent"),
);

const CardPart = styled(Card, null, "CardPart", require("./CrossSegmentCard-CardPart.module.scss"), "card-part", "cardPart");

export const CardRow = styled(Layout, null, "CardRow", require("./CrossSegmentCard-CardRow.module.scss"), "card-row", "cardRow");

export const CardCol = styled(Layout, null, "CardCol", require("./CrossSegmentCard-CardCol.module.scss"), "card-col", "cardCol");

export const CardTop = styled(CardPart, null, "CardTop", require("./CrossSegmentCard-CardTop.module.scss"), "card-top", "cardTop");

export const CardBottom = styled(CardPart, null, "CardBottom", require("./CrossSegmentCard-CardBottom.module.scss"), "card-bottom", "cardBottom");
